import React, { useState } from 'react';
import { Row, Col, Input, Select } from 'antd';
import './list-user.less';
import UserListTable from './userListTable';
import { useSelector } from 'react-redux'

const { Option } = Select;

// 用户列表页面
export default function ListUser() {
    //表格筛选查询的条件参数
    let [userStatus, setUserStatus] = useState(null);
    let [roleId, setRoleId] = useState(null);
    let [nameOrAccount, setNameOrAccount] = useState(null);
    const langValue = useSelector(state => state.langList.value)
    function handleRoleChange(value) {
        // console.log(`RoleChange ${value}`);
        setRoleId(value);
    }

    function handleStatusChange(value) {
        // console.log(`StatusChange ${value}`);
        setUserStatus(value);
    }

    function handleNameOrAcctChange(e) {
        let value = e.target.value;
        // console.log(`NameOrAcctChange`, value);
        setNameOrAccount(value);
    }


    return (
        <div className='list-user'>
            <div className='search-criteria'>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row">
                        <div className="input-wrapper">
                            <Select placeholder={langValue==0?'选择职称Select job title':(langValue==1?'选择职称':'Select job title')} onChange={handleRoleChange}>
                                <Option value={null}>{langValue==0?'全部Total':(langValue==1?'全部':'Total')}</Option>
                                <Option value="4" key="4">{langValue==0?'地区财务窗口Regional financial window':(langValue==1?'地区财务窗口':'Regional financial window')}</Option>
                                <Option value="3" key="3">{langValue==0?'一般财务同仁General financial colleagues':(langValue==1?'一般财务同仁':'General financial colleagues')}</Option>
                                <Option value="2" key="2">{langValue==0?'财务管理员Financial administrator':(langValue==1?'财务管理员':'Financial administrator')}</Option>
                            </Select>
                        </div>
                    </Col>
                    <Col className="gutter-row">
                        <div className="input-wrapper">
                            <Select placeholder={langValue==0?'选择状态Select status':(langValue==1?'选择状态':'Select status')} style={{ width: 130 }} onChange={handleStatusChange}>
                                <Option value={null}>{langValue==0?'全部Total':(langValue==1?'全部':'Total')}</Option>
                                <Option value="on" key="on">{langValue==0?'启用Active':(langValue==1?'启用':'Active')}</Option>
                                <Option value="off" key="off">{langValue==0?'停用Inactive':(langValue==1?'停用':'Inactive')}</Option>
                            </Select>
                        </div>
                    </Col>
                    <Col className="gutter-row">
                        <div className="input-wrapper">
                            <Input id="uname" placeholder={langValue==0?'输入关键词搜索Enter Keywords to Search':(langValue==1?'输入关键词搜索':'Enter Keywords to Search')} className="u-input"
                                onChange={handleNameOrAcctChange} />
                        </div>
                    </Col>
                </Row>
            </div>
            <UserListTable {...{ userStatus, roleId, nameOrAccount }} />
        </div>
    )



}
